/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {summarizeSession} from '../api'

export const useMutationSummarizeSession = createReactQueryMutationHook('summarizeSession', summarizeSession)
